import { m } from "@vega-core/paraglide/messages";

import { TriStateCheckbox } from "./TriStateCheckbox";
import type { TriState } from "./types";

type DataRoomLpAccessCellProps = {
  nodeId: string;
  nodeName: string;
  dealOpportunityId: string;
  lpName: string;
  isFolder: boolean;
  accessForNode: Record<string, boolean> | undefined;
  getTriStateForFolderDealOpportunity: (
    folderId: string,
    dealOpportunityId: string,
  ) => TriState;
  toggleFolderDealOpportunityAccess: (
    nodeId: string,
    dealOpportunityId: string,
  ) => void;
  setFileDealOpportunityAccess: (
    fileId: string,
    dealOpportunityId: string,
    val: boolean,
  ) => void;
  readOnly?: boolean;
};

export function DataRoomLpAccessCell({
  nodeId,
  nodeName,
  dealOpportunityId,
  lpName,
  isFolder,
  accessForNode,
  getTriStateForFolderDealOpportunity,
  toggleFolderDealOpportunityAccess,
  setFileDealOpportunityAccess,
  readOnly = false,
}: DataRoomLpAccessCellProps) {
  const state = isFolder
    ? getTriStateForFolderDealOpportunity(nodeId, dealOpportunityId)
    : !!accessForNode?.[dealOpportunityId];

  function handleChange() {
    if (isFolder) {
      toggleFolderDealOpportunityAccess(nodeId, dealOpportunityId);
    } else {
      setFileDealOpportunityAccess(
        nodeId,
        dealOpportunityId,
        !accessForNode?.[dealOpportunityId],
      );
    }
  }

  return (
    <td
      className="h-9 border-b border-border/primary"
      data-testid={`cell-${nodeId}-${dealOpportunityId}`}
    >
      <div className="flex h-full items-center justify-center">
        <TriStateCheckbox
          ariaLabel={m.coInvestments_dataRoom_lpAccess({
            nodeName,
            lpName,
          })}
          dataTestId={`checkbox-${nodeId}-${dealOpportunityId}`}
          onChange={readOnly ? undefined : handleChange}
          state={state}
        />
      </div>
    </td>
  );
}
